import util from '../util'

let base= window.$servicePath;

export default {
  /**
   * 获取流程的配置
   */
  flowConfig(params) {
    return util.ajax(`${base}/api/config/flowConfig`, params)
  },
  /**
   * 获取配置
   */
  moduleConfig(params) {
    return util.ajax(`${base}/api/config/moduleConfig`,params)
  },
  /**
   * 获取传阅人员
   */
  getCircularObject(taskId,params){
    return util.ajaxGet(`${base}/api/project/getCircularObject`,taskId,params)
  },
  /**
   * 获取应用功能配置
   */
  appConfig(){
    return util.ajaxGet(`${base}/api/config/appConfig`)
  },
  /**
   * 获取模块表单配置
   * @param moduleId
   * @param appId
   * @returns {*}
   */
  getModuleFormField(moduleId, appId){
    return util.ajax(`${base}/api/config/getModuleFormField`,moduleId, appId)
  }
}





// WEBPACK FOOTER //
// ./src/common/api/config.js